import type { ImageLoaderProps } from "next/image";
import { ASSET_URL } from "@/src/const";
//import { ASSET_URL, GENERAL_CDN_URL } from "@/src/const";

function imageSizeAndQuality(path?: string, quality: number = 100, width: number = 750): string {
  if (!path) {
    return "";
  }
  let _width = width ? `&w=${width}` : "";
  if (path.includes(".rentcafe.com")) {
    if (_width) {
      _width = _width.replace("&w=", "&width=");
    }
  }
  if (path.includes("?")) {
    return `${path}&q=${quality}&auto=format${_width}`;
  }
  return `${path}?q=${quality}&auto=format${_width}`;
}

function imageQualityAndSizeOptional(path?: string, quality: number = 100, width?: number, height?: number): string {
  if (!path) {
    return "";
  }
  let _width = width ? `&w=${width}` : "";
  let _height = height ? `&h=${height}` : "";
  if (path.includes(".rentcafe.com")) {
    if (_width) {
      _width = _width.replace("&w=", "&width=");
    }
    if (_height) {
      _height = _height.replace("&h=", "&height=");
    }
  }
  if (path.includes("?")) {
    return `${path}&q=${quality}&auto=format${_width}${_height}`;
  }
  return `${path}?q=${quality}&auto=format${_width}${_height}`;
}

function loaderForNextJS({ src, quality, width }: ImageLoaderProps) {
  return imageSizeAndQuality(src, quality, width);
}

function checkImageIsOnCDN(src: string, cdnURI: string = "imgix.net") {
  if (!src || typeof src !== "string") {
    return false;
  }

  if (!src.includes(ASSET_URL ?? cdnURI) && !src.includes(cdnURI)) {
    return false;
  }

  return true;
}

function nextGenFormat(cdnURL?: string): string {
  if (!cdnURL) {
    return cdnURL ?? "";
  }

  if (cdnURL.includes("&auto=format") || cdnURL.includes("?auto=format")) {
    return cdnURL;
  }

  if (cdnURL.includes("?")) {
    return `${cdnURL}&auto=format`;
  }
  return `${cdnURL}?auto=format`;
}

function imageQuality(cdnURL?: string, quality: number = 100): string {
  if (!cdnURL) {
    return cdnURL ?? "";
  }

  if (cdnURL.includes("&q=") || cdnURL.includes("?q=format")) {
    return cdnURL;
  }

  if (cdnURL.includes("?")) {
    return `${cdnURL}&q=${quality ?? 100}`;
  }
  return `${cdnURL}?q=${quality ?? 100}`;
}

function videoParams(videoUrl?: string): string {
  if (!videoUrl) {
    return videoUrl ?? "";
  }

  if (videoUrl.includes("?")) {
    return `${videoUrl}&fm=hls`;
  }
  return `${videoUrl}?fm=hls`;
}

function loadFromGeneralCDN(hash: string, ext: string) {
  return `${ASSET_URL}/cms/${hash}${ext}${ext === ".pdf" ? "?fm=pdf" : ""}`;
}

export {
  imageSizeAndQuality,
  imageQualityAndSizeOptional,
  loaderForNextJS,
  checkImageIsOnCDN,
  nextGenFormat,
  imageQuality,
  videoParams,
  loadFromGeneralCDN,
};
